import { ProctoringEkycVerificationLogic } from '@exam-center/proctoring-ekyc-verification';
import { Flex } from '@shared/components';

export default function ProctoringEkycVerificationPage() {
  return (
    <Flex sx={{ flexDirection: 'column', height: '100%', overflow: 'auto' }}>
      <Flex sx={{ flex: 1, p: (theme) => theme.spacing(6) }}>
        <ProctoringEkycVerificationLogic />
      </Flex>
    </Flex>
  );
}
